import React, { useState } from "react";
import "../styles/Profile.css";



const Profile = () => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto">
                <div className="text-center mb-12">
                    
                    <div className="profile-image"></div>
                    <h1 className="text-4xl font-bold text-gray-800 mb-4">
                        Milo & ich
                    </h1>
                    <div className="profile-image2"></div>
                    <div className="profile-image3"></div>
                </div>

        

                <div className="bg-white shadow-sm rounded-lg p-8">
                    <h2 className="text-2xl font-semibold text-gray-700 mb-4">
                        Unsere Philosophie - Weil Ihr Hund mir am Herzen liegt
                    </h2>

                    {/* Shortened Preview */}
                    <p className="text-gray-800 leading-relaxed mb-6">
                                <p>Bei <strong>Milo & Mabel Hundefriseur Scheyern</strong> steht nicht eine schnelle Standardbehandlung im Vordergrund, sondern eine <strong>individuell abgestimmte, artgerechte Fellpflege</strong>, die den Hund, Ihren Hund, als Ganzes betrachtet.</p> 
                                <p>Jeder Hund bringt andere Voraussetzungen mit - Fellstruktur, Hautzustand, Alter, Temperament, Charakter, seine gemachten Erfahrungen und gesundheitliche Aspekte, all dies fließt bei mir in jede Behandlung mit ein. Ihr Hund ist einzigartig, und genau so individuell gestalte ich auch jede Fellpflege. </p>
                                <p>Aber vor Allem liegt mir am Herzen, dass sich Ihr Hund bei mir <strong>sicher, verstanden und gut aufgehoben fühlt. </strong></p>
                    </p>
                    {/* Full Text (Shown When Expanded) */}
                    {expanded && (
                        <div className="text-gray-800 leading-relaxed mb-6">
                                <p>In ruhiger Atmosphäre, ohne Hektik und Zeitdruck, widmen ich mich Ihrem Hund mit Aufmerksamkeit, Fachwissen und viel Feingefühl. </p>
                                <h2>Hochwertige Produkte - abgestimmt auf Haut & Haar</h2>
                                <p> Für die Pflege Ihres Hundes verwende ich ausschließlich hochwertige, professionelle Pflegeprodukte, die individuell auf Haut und Fell abgestimmt werden. </p>  
                                <p> Ergänzend biete ich besondere Spa- und Pflegeanwendungen wie <strong>Thalasso-Schlammbehandlungen</strong> und <strong>NAGAYU®</strong> an. </p>
                                <h2>Waschen & Föhnen - schonend und stressarm</h2>
                                <p> Das Baden ist für mich kein „nötiges Übel“, sondern ein wichtiger Bestandteil der ganzheitlichen Fell- und Hautpflege. Ich arbeite ruhig, mit angepasster Wassertemperatur und viel Rücksicht auf das Empfinden Ihres Hundes. </p>
                                <p> Beim Trocknen setze ich auf: </p>
                                <ul>
                                <li>haarschonende Föhne</li>
                                <li>möglichst leise, regulierbare Blower</li>
                                <li>individuell abgestimmte Luftstärke und Temperatur</li>
                                </ul>
                                <p> So wird das Fell gründlich und schonend getrocknet, ohne Hautreizungen oder Stress. </p>
                                <h2>Bürsten & Kämmen - jedes Fell hat andere Anforderungen</h2>
                                <p> Jedes Haar ist anders - fein oder kräftig, glatt oder lockig, dicht oder drahtig. Und genauso individuell wie das Fell Ihres Hundes sind auch die <strong>Bürsten und Kämme</strong>, die ich einsetzen. </p>
                                <p> So kann ich: </p>
                                <ul>
                                <li>Verfilzungen sanft lösen</li>
                                <li>die Haut schonen</li>
                                <li>die Fellstruktur erhalten</li>
                                <li>ein gleichmäßiges, gepflegtes Ergebnis erzielen</li>
                                </ul>
                                <p> Das richtige Werkzeug ist dabei ebenso entscheidend wie die richtige Technik - beides wähle ich mit großer Sorgfalt für Ihren Hund aus. </p>
                                <h2>Scheren & Schneiden - Präzision mit hochwertigen Werkzeugen</h2>
                                <p> Bei Milo & Mabel werden <strong>hochwertige, leise Schermaschinen und professionelle Blades (Edelstahl u. Keramik) und Scherköpfe in unterschiedlichen Längen genutzt. </strong> Dies ermöglicht: </p>
                                <ul>
                                <li>einen gleichmäßigen, sauberen Schnitt</li>
                                <li>minimale Vibration</li>
                                <li>eine ruhige Atmosphäre für den Hund</li>
                                </ul>
                                <p> Das <strong>Schneiden mit der Schere</strong> erfolgt mit präzisen, ergonomischen Profi-Scheren, angepasst an Felltyp und gewünschte Schnittform. </p>  
                                <h2>Trimmen - mit Respekt vor Fell und Hund</h2>
                                <p> Auch beim Trimmen gilt mein Grundsatz: <strong>so sanft wie möglich, so effektiv wie nötig. </strong> Ich arbeite - wenn Werkzeuge verwendet werden - ausschließlich mit <strong>stumpfen, fellschonenden Trimmhilfen</strong> wie: </p>
                                <ul>
                                <li>Gummifingerlingen</li>
                                <li>Trimmpuder</li>
                                <li>Trimmlöffeln mit Diamantbeschichtung</li>
                                </ul>
                                <h2>Exklusive Einzelbehandlung - Ruhe und Sicherheit für Ihren Hund</h2>
                                <p> Bei<strong> Milo & Mabel Hundefriseur Scheyern</strong> behandele ich immer <strong>nur einen Hund gleichzeitig. </strong> So kann Ihr Herzenshund in einer <strong>ruhigen, stressfreien Umgebung</strong> gepflegt werden - ohne Ablenkung, Geräuschstress oder Begegnungen mit fremden Hunden. </p>
                                <p> Begegnungen mit anderen Hunden, gerade in einem Pflege- oder Salonumfeld, können <strong>unnötigen Stress, Angst oder Unsicherheit</strong> auslösen und das Wohlbefinden beeinträchtigen. Selbst entspannte Hunde können in solchen Situationen angespannt reagieren, was die Pflege erschwert und das Risiko für Verletzungen erhöht. </p>
                                <p> Mit meiner <strong>Einzelbehandlung</strong> bekommt Ihr Hund <strong>volle Aufmerksamkeit und exklusive „ICH“-Zeit. </strong> Jede Bewegung, jeder Griff und jede Pflegehandlung wird auf seine Bedürfnisse abgestimmt - so entsteht eine <strong>sichere, entspannte Atmosphäre</strong>, in der Ihr Hund sich wohlfühlen kann und die Fellpflege zur positiven Erfahrung wird. </p>
                                <h2>Was Sie bei mir finden: </h2>
                                <p> Ich nehme mir Zeit. Zeit für Ihren Hund, Zeit für Sie als Halterin oder Halter, Zeit für Fragen, Wünsche und Individualität. </p>
                                <p> Mein Ziel ist nicht nur ein gepflegtes Erscheinungsbild, sondern ein Hund, der sich <strong>gesund, sicher und wohl in seiner Haut fühlt. </strong></p>
                                <p> Bei <strong>Milo & Mabel Hundefriseur Scheyern </strong>bedeutet Fellpflege: </p>
                                <ul>
                                <li>individuelle Beratung</li>
                                <li>hochwertige Produkte und Technik</li>
                                <li>professionelle Arbeitsweise</li>
                                <li>ruhiges, respektvolles Arbeiten</li>
                                </ul>
                                <h2>Fellpflege „Pro Hund“ - weil Ihr Herzenshund auch mir am Herzen liegt. </h2>
                        </div>
                    )}

                    {/* Toggle Button */}
                    <button
                        className="toggle-button"
                        onClick={() => setExpanded(!expanded)}
                    >
                        {expanded ? "Weniger anzeigen" : "Mehr lesen"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Profile;
